import { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import {
  getCaptionDisplayConfigFlag,
  resolveCaptionDisplayConfig,
  type CaptionDisplayConfig,
} from 'features/call/call-captions/constants';

export const useCaptionDisplayConfig = (): CaptionDisplayConfig => {
  const flags = useFlags();
  const captionDisplayConfigFlag = getCaptionDisplayConfigFlag(flags);

  return useMemo(
    () => resolveCaptionDisplayConfig(captionDisplayConfigFlag),
    [captionDisplayConfigFlag]
  );
};
